/* import __COLOCATED_TEMPLATE__ from './noise-table.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';

export default class NoiseTable extends Component {
    tagName = '';

    @service('data') model;
    @service intl;

    totalNoiseMaximized = false;
    driverTotalMaximized = false;

    @computed('totalNoiseMaximized') get totalNoiseExpandCollapseIconInfo() {
        return this.getExpandCollapseIconInfo(this.totalNoiseMaximized);
    }

    @computed('driverTotalMaximized') get driverTotalNoiseExpandCollapseIconInfo() {
        return this.getExpandCollapseIconInfo(this.driverTotalMaximized);
    }

    @action showHideNoiseDetails() {
        this.set('totalNoiseMaximized', !this.totalNoiseMaximized);
    }

    @action showHideDriverNoiseDetails() {
        this.set('driverTotalMaximized', !this.driverTotalMaximized);
    }

    getExpandCollapseIconInfo(maximized) {
        if (maximized)
            return {
                alt: this.intl.t('labels.collapse'),
                src: 'svgs/icons/Icon_Collapse.svg',
            };
        else
            return {
                alt: this.intl.t('labels.expand'),
                src: 'svgs/icons/Icon_Expand.svg',
            };
    }
}
